import { api } from './api';
import type { ProposedArticle, ProposedArticleStatus, NewsKeywordSuggestion } from '@traaker/shared';

export const proposedArticlesApi = {
  list: (brandId: string, status?: ProposedArticleStatus) => {
    const params = new URLSearchParams({ brandId });
    if (status) params.set('status', status);
    return api.get<ProposedArticle[]>(`/proposed-articles?${params.toString()}`);
  },

  updateStatus: (
    articleId: string,
    body: { brandId: string; status: ProposedArticleStatus; publishedUrl?: string },
  ) => api.patch<ProposedArticle>(`/proposed-articles/${articleId}`, body),

  getSuggestedKeywords: (brandId: string) =>
    api.get<NewsKeywordSuggestion[]>(`/proposed-articles/suggested-keywords?brandId=${brandId}`),
};
